import 'config';
import angular from 'angular';
import 'regenerator-runtime/runtime';
import constants from '../constants';
import services from '../services';
import directives from '../directives';
import widgets from '../widgets';
import sprintPopup from './components/popups/sprint';
import userPopup from './components/popups/user-popup';
import createLogger from 'redux-logger';
import rootSaga from '../redux/store/saga';
import rootReducer from '../redux/store/reducer';
import createSagaMiddleware from 'redux-saga';
import ngRedux from 'ng-redux';
import ngReduxRoute from 'ng-redux-route';
import * as actions from 'redux/store/actions';
import difference from '../utils/difference';
import projectSelector from '../widgets/project-selector';
import licensePopup from './components/popups/license-popup';
import progressBar from './components/progress-bar';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import ngCookies from 'angular-cookies';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import  moment from 'moment';

const sagaMiddleware = createSagaMiddleware();

const core = angular.module('ttb.core', [
    constants,
    services,
    directives,
    ngRedux,
    ngReduxRoute,
    widgets,
    sprintPopup,
    userPopup,
    licensePopup,
    progressBar,
    'pascalprecht.translate',
    ngCookies
]).config(($ngReduxProvider,  $translateProvider) => {
    const middlewares = ['ngRouteMiddleware', sagaMiddleware];
      $translateProvider
                .useStaticFilesLoader({
                    prefix: '/scripts/translations/',
                    suffix: '_v2.json'
                })
            $translateProvider.useLocalStorage();
            $translateProvider.useSanitizeValueStrategy(null);
            $translateProvider.preferredLanguage('en');
    if (DEBUG) {
        middlewares.push(createLogger({
            level: 'info',
            collapsed: true,
        }));
    }
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        $ngReduxProvider.createStoreWith(rootReducer, middlewares, [window.__REDUX_DEVTOOLS_EXTENSION__()]);
    } else {
        $ngReduxProvider.createStoreWith(rootReducer, middlewares);
    }
})
    .run(($ngRedux, $rootScope, $location, $window,  $translate) => {
        $translate.use(ttb.constants.cultureName)
        moment.locale(ttb.constants.cultureName);
        sagaMiddleware.run(rootSaga);
        // track pageview on state change
        const pageView = () => {
            $window.gtag('config', ttb.constants.gaTrackingId, {
                page_location: $location.absUrl()
            });
        };
        $rootScope.$on('$routeChangeSuccess', pageView);
        $rootScope.$on('$stateChangeSuccess', pageView);

        angular.bootstrap(document.getElementById('project-selector-menu'), [projectSelector]);
    })
    .constant('actions', actions)
    .constant('difference', difference)
    .name;

export default core;



// WEBPACK FOOTER //
// ./index.js